import React, { useContext, useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { f, database, storage, auth } from "../config";
import firebase from "firebase";
import db from "../config";
import { GlobalContext } from "../Globalstate";
import Swal from "sweetalert2";
import axios from "axios";

function Deposits() {
  const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] =
    useContext(GlobalContext);
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [adminusers, setadminusers] = useState([]);

  const [dataAvailable, setdataAvailable] = useState(false);
  const [lastdocument, setlastdocument] = useState(null);

  function cleanDate(d) {
    var date = new Date(d);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    console.log(
      "Date: " +
        date.getDate() +
        "/" +
        months[date.getMonth() + 1] +
        "/" +
        date.getFullYear() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
    );
    return `${date.getDate()} ${
      months[date.getMonth()]
    } ${date.getFullYear()}  ${date.getHours()}  ${date.getMinutes()} ${date.getSeconds()}`;
  }

  useEffect(() => {
    authcheck();
  }, []);

  const authcheck = async () => {
    setloading(true);
    const userdata = await f.auth().onAuthStateChanged(function (user) {
      if (user) {
        var userid = f.auth().currentUser;
        var userids = userid.uid;
        if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
          adminfetchall();
        } else {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    });
  };

  const setSelecteduser = (data) => {
    dispatch({ type: "setsingleuser", snippet: data });
  };

  const adminfetchall = async () => {
    const data = await db
      .collection("deposits")
      .orderBy("timestamp", "desc")
      .limit(10)
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          let User = doc.data();
          User.id = doc.id;
          adminusers.push(User);
        });
        console.log(snapshot.docs[snapshot.docs.length - 1]);
        setlastdocument(snapshot.docs[snapshot.docs.length - 1]);
      });

    setloading(false);
    console.log(adminusers);
    setdataAvailable(true);
  };

  const getNextDocuments = async () => {
    const ref = db
      .collection("deposits")
      .orderBy("timestamp", "desc")
      .startAfter(lastdocument || 0)
      .limit(10);
    const data = await ref.get();

    data.docs.forEach((doc) => {
      console.log(doc);
      let User = doc.data();
      User.id = doc.id;
      adminusers.push(User);
    });

    setlastdocument(data.docs[data.docs.length - 1]);
    console.log(data.docs[data.docs.length - 1]);
    console.log(adminusers);
    setdataAvailable(true);
  };

  const UpdateDeposit = async (
    depositToUpdate,
    UID,
    info,
    depositid,
    fullname
  ) => {
    Swal.fire({
      title: `do you want to Approve this Deposit `,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        planactivation(depositToUpdate, UID, fullname);
        SendMailtoClient(
          info.email,
          info.fullname,
          depositToUpdate.amt,
          depositToUpdate.coin,
          depositid
        );
      }
    });
  };

  const SendMailtoClient = async (email, fullname, amount, coin, depositid) => {
    setloading(true);

    const htmlToSend = `
      <center style="width: 100%; background-color: #f1f1f1;">
        <div class="email-container" style="max-width: 600px; margin: 0 auto;">
          <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0" align="center">
            <tbody>
              <tr>
                <td class="bg_white" style="padding: 1em 2.5em 0 2.5em;" valign="top">
                  <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td class="logo" style="text-align: left;">
                          <img src="https://firebasestorage.googleapis.com/v0/b/globalfoxtrades-c57bd.appspot.com/o/logo-com.png?alt=media&token=cd4dfcc5-ad62-4552-b3ff-71c79614733a" alt="Logo" style="max-width: 100%; height: auto;" />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
              <tr>
                <td class="hero bg_white" style="padding: 2em 0 2em 0;" valign="middle">
                  <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0">
                    <tbody>
                      <tr>
                        <td style="padding: 0 2.5em; text-align: left;">
                          <div class="text">
                            <h4>Globalfoxtrades - Deposit Notification</h4>
                            <h4>Hello ${fullname}</h4>
                            <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none; mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333; font-size: 14px;">
                              <strong>Your deposit of $${amount} of ${coin} has been successfully processed and is now available for investment in your account</strong>
                              <br />
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <p>For enquires/complaints contact the Admin via any of the communication channels</p>
        </div>
      </center>
    `;

    try {
      // Switched to use the unified https://activerendbackend.onrender.com/send-mail endpoint
      const response = await axios.post("https://activerendbackend.onrender.com/send-mail", {
        htmlToSend,
        email,
        subject: "Deposit Confirmation",
        CompanyName: "Globalfoxtrades",
      });

      console.log(response.data.message);

      // Proceed to delete the deposit document upon successful email dispatch
      await db.collection("deposits").doc(depositid).delete();
      console.log("Document successfully deleted!");
      Swal.fire("Deleted!", "The Deposit has been confirmed.", "success");
      
    } catch (error) {
      console.error("Error processing deposit or sending email:", error);
      Swal.fire("Error!", "Failed to process the deposit confirmation.", "error");
    } finally {
      setloading(false);
    }
  };

  const investments = [
    {
      title: "STARTER PLAN 1",
      minDeposit: 200.0,
      maxDeposit: 1000.0,
      planDuration: 3,
      dailyProfit: "6%",
      profitReturn: 6,
      referralBonus: "5%",
      radio: 80,
    },
    {
      title: "CLASSIC PLAN 2",
      minDeposit: 2000.0,
      maxDeposit: 6000.0,
      planDuration: 5,
      dailyProfit: "8%",
      profitReturn: 8,
      referralBonus: "5%",
      radio: 81,
    },
    {
      title: "STOCKS PLAN 3",
      minDeposit: 7000.0,
      maxDeposit: 10000.0,
      planDuration: 7,
      dailyProfit: "12%",
      profitReturn: 12,
      referralBonus: "5%",
      radio: 82,
    },
    {
      title: "PROFESSIONAL PLAN",
      minDeposit: 20000.0,
      maxDeposit: 1000000000000000000000000,
      planDuration: 10,
      dailyProfit: "16%",
      profitReturn: 16,
      referralBonus: "5%",
      radio: 83,
    }
  ];

  function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
  }

  const planactivation = (depositInfo, userId, fullname) => {
    let SelectedInvestment = investments.find(
      (o) => o.title === depositInfo.investmentplan
    );

    Swal.fire({
      title: "Are you sure?",
      text: `Do you really want to invest in ${SelectedInvestment.title}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, continue",
    }).then((result) => {
      if (result.isConfirmed) {
        let AMT1 = parseInt(depositInfo.amt);
        let due =
          parseFloat(SelectedInvestment.planDuration) *
            ((parseFloat(SelectedInvestment.dailyProfit) / 100) * AMT1) +
          AMT1;
        let myDate = new Date();
        const d2 = addHoursToDate(
          myDate,
          parseFloat(SelectedInvestment.planDuration) * 24
        ).getTime();
        var cap = new Date(d2);
        console.log(cap.toString());
        const subscription = {
          coinUsed: depositInfo.coin,
          amount: AMT1,
          currentPlan: SelectedInvestment.title,
          dueAmount: due,
          dueDate: d2,
          dateSubscribed: new Date().getTime(),
        };
        updateUserBalanceAndSub(
          subscription,
          SelectedInvestment.title,
          due,
          userId,
          fullname
        );
        Swal.fire(
          "Succesful Transaction!",
          "Your Investment has been activated.",
          "success"
        );
      }
    });
  };

  const updateUserBalanceAndSub = (
    subsription,
    plans,
    intrest,
    userid,
    fullname
  ) => {
    var washingtonRef = db.collection("users").doc(userid);
    const increment = firebase.firestore.FieldValue.increment(
      subsription.amount
    );
    washingtonRef
      .update({
        currentSubscription: subsription,
        Totaldeposit: increment,
        currentSubscriptionArray:
          firebase.firestore.FieldValue.arrayUnion(subsription),
        Investments: firebase.firestore.FieldValue.arrayUnion({
          date: Date.now(),
          plan: plans,
        }),
      })
      .then(function () {
        console.log("Document successfully updated!");
        CreatUserObj(
          {
            date: Date.now(),
            plan: plans,
            amount: subsription.amount,
            userid: userid,
          },
          subsription,
          userid,
          fullname
        );
      })
      .catch(function (error) {
        console.error("Error updating document: ", error);
      });
  };

  const CreatUserObj = async (obj, subsription, userid, fullanme) => {
    let uobj = {
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userid: userid,
      info: obj,
      subsription: subsription,
      fullname: fullanme,
    };
    const userdetail1 = await db
      .collection("investments")
      .add(uobj)
      .then(function () {
        console.log("Document successfully written!");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };

  const deleteDeposit = (uid) => {
    console.log(uid);
    Swal.fire({
      title: "Are you sure You want to delete this deposit?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        db.collection("deposits")
          .doc(uid)
          .delete()
          .then(() => {
            console.log(uid);
            console.log("Document successfully deleted!");
            Swal.fire("Deleted!", "The Deposit has been deleted.", "success");
            navigate("/");
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
    });
  };

  return (
    <div>
      {/* Site wrapper */}
      <div className="wrapper">
        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          {/* Left navbar links */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <a
                className="nav-link"
                data-widget="pushmenu"
                href="#"
                role="button"
              >
                <i className="fas fa-bars" />
              </a>
            </li>
          </ul>
        </nav>
        {/* /.navbar */}
        {/* Main Sidebar Container */}
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
          {/* Brand Logo */}
          <a href="https://chainblockinvestment.com" className="brand-link">
            <img
              src="https://img.icons8.com/?size=80&id=68733&format=png"
              className="brand-image img-circle elevation-2"
              style={{ opacity: ".8" }}
              width={30}
            />
            <span className="brand-text font-weight-light">
              Investment Admin
            </span>
          </a>
          {/* Sidebar */}
          <div className="sidebar">
            {/* Sidebar user (optional) */}
            <div className="user-panel mt-3 pb-3 mb-3 d-flex">
              <div className="image">
                <img
                  src="https://img.icons8.com/bubbles/1x/administrator-male.png"
                  className="img-circle elevation-2"
                  alt="User Image"
                />
              </div>
              <div className="info">
                <a href="#" className="d-block">
                  Darkest Mind
                </a>
              </div>
            </div>
            {/* Sidebar Menu */}
            <nav className="mt-2">
              <ul
                className="nav nav-pills nav-sidebar flex-column"
                data-widget="treeview"
                role="menu"
                data-accordion="false"
              >
                <li className="nav-item">
                  <a href="/" className="nav-link">
                    <i className="nav-icon fas fa-tachometer-alt" />
                    <p>Dashboard</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/users" className="nav-link">
                    <i className="nav-icon fas fa-users" />
                    <p>Manage Users</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/deposits" className="nav-link">
                    <i className="nav-icon fas fa-donate" />
                    <p>Manage Deposits</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/withdrawals" className="nav-link">
                    <i className="nav-icon fas fa-hand-holding-usd" />
                    <p>Manage Withdrawals</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/investments" className="nav-link">
                    <i className="nav-icon fas fa-hand-holding-usd" />
                    <p>Manage Investments</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="https://privateemail.com/" className="nav-link">
                    <i className="nav-icon fas fa-envelope" />
                    <p>webmail</p>
                  </a>
                </li>
                <li className="nav-item">
                  <a href="/logout" className="nav-link">
                    <i className="nav-icon fas fa-power-off" />
                    <p>Logout</p>
                  </a>
                </li>
              </ul>
            </nav>
            {/* /.sidebar-menu */}
          </div>
          {/* /.sidebar */}
        </aside>
        {/* Content Wrapper. Contains page content */}
        <div className="content-wrapper" style={{ minHeight: "777px" }}>
          {/* Content Header (Page header) */}
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1>Manage Deposits</h1>
                </div>
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item">
                      <a href="https://chainblockinvestment.com/admin">Home</a>
                    </li>
                    <li className="breadcrumb-item active">Manage Deposits</li>
                  </ol>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </section>
          {/* Main content */}
          <section className="content">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <div
                            id="deposit_table_wrapper"
                            className="dataTables_wrapper dt-bootstrap4 no-footer"
                          >
                            <div className="row">
                              <div className="col-sm-12 col-md-6" />
                              <div className="col-sm-12 col-md-6">
                                <div
                                  id="deposit_table_filter"
                                  className="dataTables_filter"
                                >
                                  <label>
                                    Search:
                                    <input
                                      type="search"
                                      className="form-control form-control-sm"
                                      placeholder
                                      aria-controls="deposit_table"
                                    />
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-sm-12">
                                <table
                                  className="table table-striped dataTable no-footer"
                                  id="deposit_table"
                                  data-page-length={20}
                                  role="grid"
                                  aria-describedby="deposit_table_info"
                                >
                                  <thead>
                                    <tr role="row">
                                      <th
                                        style={{ width: "1%" }}
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        #
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      ></th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Name
                                      </th>
                                      <th
                                        width="10%"
                                        className="text-right sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        email
                                      </th>
                                      <th
                                        width="5%"
                                        className="text-center sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Usd Equivalent
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Wallet Address
                                      </th>
                                      <th
                                        width="5%"
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Hash Code
                                      </th>
                                      <th
                                        className="sorting_disabled"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Created Date
                                      </th>
                                      <th
                                        className="text-center sorting_disabled"
                                        width="10%"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Action
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {adminusers &&
                                      adminusers.map((info, i) => {
                                        return (
                                          <tr
                                            role="row"
                                            className="odd"
                                            key={info.userid}
                                          >
                                            <td>{i}</td>
                                            <td>
                                              <img
                                                src="https://img.icons8.com/bubbles/1x/administrator-male.png"
                                                className="img-fluid img-circle elevation-2 bg-light"
                                                width="30px"
                                                alt="User Avatar"
                                              />
                                            </td>
                                            <td>{info.fullname}</td>
                                            <td>{info.email}</td>
                                            <td>{info.info.amt}</td>
                                            <td>{info.info.coin}</td>
                                            <td>{info.info.date}</td>
                                            <td>{cleanDate(info.info.date)}</td>
                                            <td className="text-center">
                                              <button
                                                className="btn btn-dark btn-sm"
                                                onClick={() => {
                                                  UpdateDeposit(
                                                    info.info,
                                                    info.userid,
                                                    info,
                                                    info.id,
                                                    info.fullname
                                                  );
                                                }}
                                              >
                                                <i className="fas fa-check"></i>
                                              </button>

                                              <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => {
                                                  deleteDeposit(info.id);
                                                }}
                                              >
                                                <i className="fas fa-trash"></i>
                                                Delete
                                              </button>
                                            </td>
                                            <td>
                                              <a
                                                href={info.info.image}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                              >
                                                view proof
                                              </a>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                  </tbody>
                                </table>
                              </div>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={getNextDocuments}
                              >
                                Load more
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /.card-body */}
                    </div>
                  </div>
                </div>
                {/* /.box */}
              </div>
            </div>
          </section>
          {/* /.content */}
        </div>
        {/* /.content-wrapper */}
        <footer className="main-footer">
          <div className="float-right d-none d-sm-block">
            <b>Version</b> 3.0.4
          </div>
          <strong>
            Copyright © 2022{" "}
            <a href="https://chainblockinvestment.com">Investment Admin</a>.
          </strong>{" "}
          All rights reserved.
        </footer>
        <div id="sidebar-overlay" />
      </div>
      {/* ./wrapper */}
    </div>
  );
}

export default Deposits;

// import React, { useContext, useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { f, database, storage, auth } from "../config";
// import firebase from "firebase";
// import db from "../config";
// import { GlobalContext } from "../Globalstate";
// import Swal from "sweetalert2";
// import emailjs from "emailjs-com";
// import axios from "axios";

// function Deposits() {
//   const [{ userdetails, loggedin, singleuser, singleuserkyc }, dispatch] =
//     useContext(GlobalContext);
//   const navigate = useNavigate();
//   const [loading, setloading] = useState(false);
//   const [adminusers, setadminusers] = useState([]);

//   const [dataAvailable, setdataAvailable] = useState(false);
//   const [lastdocument, setlastdocument] = useState(null);

//   function cleanDate(d) {
//     var date = new Date(d);
//     var months = [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "Jun",
//       "Jul",
//       "Aug",
//       "Sep",
//       "Oct",
//       "Nov",
//       "Dec",
//     ];
//     console.log(
//       "Date: " +
//         date.getDate() +
//         "/" +
//         months[date.getMonth() + 1] +
//         "/" +
//         date.getFullYear() +
//         " " +
//         date.getHours() +
//         ":" +
//         date.getMinutes() +
//         ":" +
//         date.getSeconds()
//     );
//     return `${date.getDate()} ${
//       months[date.getMonth()]
//     } ${date.getFullYear()}  ${date.getHours()}  ${date.getMinutes()} ${date.getSeconds()}`;
//   }
//   useEffect(() => {
//     authcheck();
//   }, []);
//   const authcheck = async () => {
//     setloading(true);
//     const userdata = await f.auth().onAuthStateChanged(function (user) {
//       if (user) {
//         var userid = f.auth().currentUser;
//         var userids = userid.uid;
//         if (userids == "vKSvpr8AdihqQJ1KT3DCItILBqw2") {
//           adminfetchall();
//         } else {
//           navigate("/login");
//         }
//         // console.log(adminusers);
//         //  setloggedin(true);
//       } else {
//         navigate("/login");
//       }
//     });
//   };

//   const setSelecteduser = (data) => {
//     dispatch({ type: "setsingleuser", snippet: data });
//     //setshowmodal(true)
//     // navigate("/adminviews");
//     // handleOpen()
//   };

//   const adminfetchall = async () => {
//     const data = await db
//       .collection("deposits")
//       .orderBy("timestamp", "desc")
//       .limit(10)
//       .get()
//       .then((snapshot) => {
//         snapshot.forEach((doc) => {
//           let User = doc.data();
//           User.id = doc.id;
//           adminusers.push(User);
//         });
//         console.log(snapshot.docs[snapshot.docs.length - 1]);
//         setlastdocument(snapshot.docs[snapshot.docs.length - 1]);
//       });

//     setloading(false);

//     console.log(adminusers);
//     const set = await setdataAvailable(true);
//   };

//   const getNextDocuments = async () => {
//     const ref = db
//       .collection("deposits")
//       .orderBy("timestamp", "desc")
//       .startAfter(lastdocument || 0)
//       .limit(10);
//     const data = await ref.get();

//     data.docs.forEach((doc) => {
//       console.log(doc);
//       let User = doc.data();
//       User.id = doc.id;
//       adminusers.push(User);
//     });

//     setlastdocument(data.docs[data.docs.length - 1]);
//     console.log(data.docs[data.docs.length - 1]);
//     console.log(adminusers);
//     setdataAvailable(true);
//   };

//   const UpdateDeposit = async (
//     depositToUpdate,
//     UID,
//     info,
//     depositid,
//     fullname
//   ) => {
//     //
//     Swal.fire({
//       title: `do you want to Approve this Deposit `,
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         planactivation(depositToUpdate, UID, fullname);
//         SendMailtoClient(
//           info.email,
//           info.fullname,
//           depositToUpdate.amt,
//           depositToUpdate.coin,
//           depositid
//         );
//         // console.log(depositToUpdate.amt)
//       }
//     });
//   };

//   ///////////////////////////////////
//   /////////////////////////////////
//   ///////////////////////////////////
//   /////////////////////////////////
//   ///////////////////////////////////
//   /////////////////////////////////
//   ///////////////////////////////////
//   /////////////////////////////////
//   ///////////////////////////////////
//   /////////////////////////////////
//   async function sendEmail(user, pass, htmlToSend, email, subject) {
//     // https://renderallmybackend.onrender.com/
//     const url = "https://renderallmybackend.onrender.comhttps://activerendbackend.onrender.com/send-mail"; // Replace with your actual server URL
//     try {
//       const response = await axios.post(url, {
//         htmlToSend: htmlToSend,
//         user: user,
//         pass: pass,
//         email: email, //email
//         subject: subject,
//         CompanyName: "Globalfoxtrades",
//       });
//       console.log(response.data.message); // Log the success message
//       Swal.fire("Processing!", "The Withdrawal is Being Processed.", "success");
//     } catch (error) {
//       console.error(error);
//       // Handle errors appropriately, e.g., display error message to the user
//     }
//   }

//   const SendMailtoClient = async (email, fullname, amount, coin, depositid) => {
//     var templateParams = {
//       to_name: fullname,
//       message: ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
//             mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
//             font-size: 14px;"><strong>Your deposit of $${amount} of ${coin} has been successfully processed and is now available for investment in your account</strong>
//             <br ></br>
//            </div>`,

//       user_email: email,
//       notification: "Deposit",
//     };

//     setloading(false);
//     emailjs
//       .send(
//         "service_cr3rasvvv5",
//         "template_w9xbvvipg",
//         templateParams,
//         "Jmooxj6VzmE8UFTvvvhu"
//       )
//       .then(
//         function (response) {
//           db.collection("deposits")
//             .doc(depositid)
//             .delete()
//             .then(() => {
//               console.log(depositid);
//               console.log("Document successfully deleted!");
//               //navigate("/");
//               Swal.fire(
//                 "Deleted!",
//                 "The Deposit has been confirmed.",
//                 "success"
//               );
//               // navigate("/");
//             })
//             .catch((error) => {
//               console.error("Error removing document: ", error);
//             });
//           setloading(false);
//         },
//         function (err) {
//           setloading(false);
//           console.log(err);
//           emailjs
//             .send(
//               "service_mj5xmccc0a",
//               "template_6mp7ccc0jg",
//               templateParams,
//               "amB0f3bGs0j4iMtcccccaI"
//             )
//             .then(
//               function (response) {
//                 db.collection("deposits")
//                   .doc(depositid)
//                   .delete()
//                   .then(() => {
//                     console.log(depositid);
//                     console.log("Document successfully deleted!");
//                     // //navigate("/");
//                     Swal.fire(
//                       "Deleted!",
//                       "The Deposit has been confirmed.",
//                       "success"
//                     );
//                     // navigate("/");
//                   })
//                   .catch((error) => {
//                     console.error("Error removing document: ", error);
//                   });
//                 setloading(false);
//               },
//               function (err) {
//                 setloading(false);
//                 console.log(err);
//                 emailjs
//                   .send(
//                     "service_54lshcccco5",
//                     "template_oflmnccccgm",
//                     templateParams,
//                     "27GUCCygiOBPUNcccccSKd"
//                   )
//                   .then(
//                     function (response) {
//                       db.collection("deposits")
//                         .doc(depositid)
//                         .delete()
//                         .then(() => {
//                           console.log(depositid);
//                           console.log("Document successfully deleted!");
//                           // //navigate("/");
//                           Swal.fire(
//                             "Deleted!",
//                             "The Deposit has been confirmed.",
//                             "success"
//                           );
//                           // navigate("/");
//                         })
//                         .catch((error) => {
//                           console.error("Error removing document: ", error);
//                         });
//                       setloading(false);
//                     },
//                     function (err) {
//                       ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       const htmlTemplate = `
//                         <center style="width: 100%; background-color: #f1f1f1;">
//                           <div class="email-container" style="max-width: 600px; margin: 0 auto;">
//                             <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0" align="center">
//                               <tbody>
//                                 <tr>
//                                   <td class="bg_white" style="padding: 1em 2.5em 0 2.5em;" valign="top">
//                                     <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0">
//                                       <tbody>
//                                         <tr>
//                                           <td class="logo" style="text-align: left;">
//                                             <img src="https://firebasestorage.googleapis.com/v0/b/globalfoxtrades-c57bd.appspot.com/o/logo-com.png?alt=media&token=cd4dfcc5-ad62-4552-b3ff-71c79614733a">
//                                           </td>
//                                         </tr>
//                                       </tbody>
//                                     </table>
//                                   </td>
//                                 </tr>
//                                 <tr>
//                                   <td class="hero bg_white" style="padding: 2em 0 2em 0;" valign="middle">
//                                     <table role="presentation" border="0" width="100%" cellspacing="0" cellpadding="0">
//                                       <tbody>
//                                         <tr>
//                                           <td style="padding: 0 2.5em; text-align: left;">
//                                             <div class="text">
//                                               <h4>Globalfoxtrades- {{notification}}</h4>
//                                               <h4>Hello {{to_name}}</h4>
//                                               <h4>{{{message}}}</h4>
//                                             </div>
//                                           </td>
//                                         </tr>
//                                       </tbody>
//                                     </table>
//                                   </td>
//                                 </tr>
//                               </tbody>
//                             </table>
//                             <p>For enquires/compliants contact the Admin via any of the communication channels</p>
//                           </div>
//                         </center>
//                         `;
//                       const message = ` <div style="margin: 0; -webkit-text-size-adjust: none; -ms-text-size-adjust: none;
//                         mso-line-height-rule: exactly; font-family: arial,'helvetica neue', helvetica, sans-serif; line-height: 21px; color: #333333;
//                         font-size: 14px;"><strong>Your deposit of $${amount} of ${coin} has been successfully processed and is now available for investment in your account</strong>
//                         <br ></br>
//                        </div>`;
//                       const replacedHtml = htmlTemplate
//                         .replace(/{{notification}}/g, "Deposit") // Replace all occurrences
//                         .replace(/{{to_name}}/g, fullname)
//                         .replace(/{{{message}}}/g, message);
//     const user = "support@globalsfoxstrades.com"; // Replace with your email
//     const pass = "dedede23@sdde"; // Replace with your email password
//                       const emails = email; // Replace with recipient's email
//                       const subject = "Deposit"; // Replace with the subject of the email
//                       sendEmail(user, pass, replacedHtml, emails, subject);

//                       ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//                       setloading(false);
//                       console.log(err);
//                     }
//                   );
//               }
//             );
//         }
//       );
//   };

//   ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//   //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//   const investments = [
//     {
//       title: "STARTER PLAN 1",
//       minDeposit: 200.0,
//       maxDeposit: 1000.0,
//       planDuration: 3,
//       dailyProfit: "6%",
//       profitReturn: 6,
//       referralBonus: "5%",
//       radio: 80,
//     },
//     {
//       title: "CLASSIC PLAN 2",
//       minDeposit: 2000.0,
//       maxDeposit: 6000.0,
//       planDuration: 5,
//       dailyProfit: "8%",
//       profitReturn: 8,
//       referralBonus: "5%",
//       radio: 81,
//     },
//     {
//       title: "STOCKS PLAN 3",
//       minDeposit: 7000.0,
//       maxDeposit: 10000.0,
//       planDuration: 7,
//       dailyProfit: "12%",
//       profitReturn: 12,
//       referralBonus: "5%",
//       radio: 82,
//     },
//     {
//       title: "PROFESSIONAL PLAN",
//       minDeposit: 20000.0,
//       maxDeposit: 1000000000000000000000000,
//       planDuration: 10,
//       dailyProfit: "16%",
//       profitReturn: 16,
//       referralBonus: "5%",
//       radio: 83,
//     }
//   ];

//   function addHoursToDate(date, hours) {
//     return new Date(new Date(date).setHours(date.getHours() + hours));
//   }
//   const planactivation = (depositInfo, userId, fullname) => {
//     let SelectedInvestment = investments.find(
//       (o) => o.title === depositInfo.investmentplan
//     );
//     // console.log(obj)

//     Swal.fire({
//       title: "Are you sure?",
//       text: `Do you relly want to invest in ${SelectedInvestment.title}`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, continue",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         let AMT1 = parseInt(depositInfo.amt);
//         // if (value == "1" && AMT1 >= 300 && AMT1 <= 10000) {
//         // 92 no of days 1.8 is percent
//         let due =
//           parseFloat(SelectedInvestment.planDuration) *
//             ((parseFloat(SelectedInvestment.dailyProfit) / 100) * AMT1) +
//           AMT1;
//         let myDate = new Date();
//         // multiply number of days with 24
//         const d2 = addHoursToDate(
//           myDate,
//           parseFloat(SelectedInvestment.planDuration) * 24
//         ).getTime();
//         var cap = new Date(d2);
//         console.log(cap.toString());
//         const subscription = {
//           coinUsed:depositInfo.coin,
//           amount: AMT1,
//           currentPlan: SelectedInvestment.title,
//           dueAmount: due,
//           dueDate: d2,
//           dateSubscribed: new Date().getTime(),
//         };
//         updateUserBalanceAndSub(
//           subscription,
//           SelectedInvestment.title,
//           due,
//           userId,
//           fullname
//         );
//         Swal.fire(
//           "Succesful Transaction!",
//           "Your Investment has been activated.",
//           "success"
//         );
//       }
//     });
//   };

//   const updateUserBalanceAndSub = (
//     subsription,
//     plans,
//     intrest,
//     userid,
//     fullname
//   ) => {
//     var washingtonRef = db.collection("users").doc(userid);
//     const increment = firebase.firestore.FieldValue.increment(
//       subsription.amount
//     );
//     washingtonRef
//       .update({
//         currentSubscription: subsription,
//         Totaldeposit: increment,
//         // Totaldeposit:increment,
//         // totalearnings: increment,
//         currentSubscriptionArray:
//           firebase.firestore.FieldValue.arrayUnion(subsription),
//         Investments: firebase.firestore.FieldValue.arrayUnion({
//           date: Date.now(),
//           plan: plans,
//         }),
//       })
//       .then(function () {
//         console.log("Document successfully updated!");
//         CreatUserObj(
//           {
//             date: Date.now(),
//             plan: plans,
//             amount: subsription.amount,
//             userid: userid,
//           },
//           subsription,
//           userid,
//           fullname
//         );
//       })
//       .catch(function (error) {
//         console.error("Error updating document: ", error);
//       });
//   };

//   const CreatUserObj = async (obj, subsription, userid, fullanme) => {
//     let uobj = {
//       timestamp: firebase.firestore.FieldValue.serverTimestamp(),
//       // fullname: userdetails.fullname,
//       // email: userdetails.email,
//       userid: userid,
//       info: obj,
//       subsription: subsription,
//       fullname: fullanme,
//     };
//     const userdetail1 = await db
//       .collection("investments")
//       .add(uobj)
//       .then(function () {
//         console.log("Document successfully written!");
//       })
//       .catch(function (error) {
//         console.error("Error writing document: ", error);
//       });
//   };

//   const deleteDeposit = (uid) => {
//     console.log(uid);
//     Swal.fire({
//       title: "Are you sure You want to delete this deposit?",
//       text: "You won't be able to revert this!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         db.collection("deposits")
//           .doc(uid)
//           .delete()
//           .then(() => {
//             console.log(uid);
//             console.log("Document successfully deleted!");
//             //navigate("/");
//             Swal.fire("Deleted!", "The Deposit has been deleted.", "success");
//             navigate("/");
//           })
//           .catch((error) => {
//             console.error("Error removing document: ", error);
//           });
//       }
//     });
//   };

//   return (
//     <div>
//       {/* Site wrapper */}
//       <div className="wrapper">
//         {/* Navbar */}
//         <nav className="main-header navbar navbar-expand navbar-white navbar-light">
//           {/* Left navbar links */}
//           <ul className="navbar-nav">
//             <li className="nav-item">
//               <a
//                 className="nav-link"
//                 data-widget="pushmenu"
//                 href="#"
//                 role="button"
//               >
//                 <i className="fas fa-bars" />
//               </a>
//             </li>
//           </ul>
//         </nav>
//         {/* /.navbar */}
//         {/* Main Sidebar Container */}
//         <aside className="main-sidebar sidebar-dark-primary elevation-4">
//           {/* Brand Logo */}
//           <a href="https://chainblockinvestment.com" className="brand-link">
//             <img
//               src="https://img.icons8.com/?size=80&id=68733&format=png"
//               className="brand-image img-circle elevation-2"
//               style={{ opacity: ".8" }}
//               width={30}
//             />
//             <span className="brand-text font-weight-light">
//               Investment Admin
//             </span>
//           </a>
//           {/* Sidebar */}
//           <div className="sidebar">
//             {/* Sidebar user (optional) */}
//             <div className="user-panel mt-3 pb-3 mb-3 d-flex">
//               <div className="image">
//                 <img
//                   src="https://img.icons8.com/bubbles/1x/administrator-male.png"
//                   className="img-circle elevation-2"
//                   alt="User Image"
//                 />
//               </div>
//               <div className="info">
//                 <a href="#" className="d-block">
//                   Darkest Mind
//                 </a>
//               </div>
//             </div>
//             {/* Sidebar Menu */}
//             <nav className="mt-2">
//               <ul
//                 className="nav nav-pills nav-sidebar flex-column"
//                 data-widget="treeview"
//                 role="menu"
//                 data-accordion="false"
//               >
//                 {/* Add icons to the links using the .nav-icon class
//            with font-awesome or any other icon font library */}
//                 <li className="nav-item">
//                   <a href="/" className="nav-link">
//                     <i className="nav-icon fas fa-tachometer-alt" />
//                     <p>Dashboard</p>
//                   </a>
//                 </li>
//                 {/* <li className="nav-item">
//                                     <a href="/Settings" className="nav-link">
//                                         <i className="nav-icon fas fa-tachometer-alt" />
//                                         <p>
//                                             Coin Deposit
//                                         </p>
//                                     </a>
//                                 </li> */}
//                 <li className="nav-item">
//                   <a href="/users" className="nav-link">
//                     <i className="nav-icon fas fa-users" />
//                     <p>Manage Users</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/deposits" className="nav-link">
//                     <i className="nav-icon fas fa-donate" />
//                     <p>Manage Deposits</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/withdrawals" className="nav-link">
//                     <i className="nav-icon fas fa-hand-holding-usd" />
//                     <p>Manage Withdrawals</p>
//                   </a>
//                 </li>

//                 {/* <li className="nav-item has-treeview">
//                                     <a href="#" className="nav-link">
//                                         <i className="nav-icon fab fa-pagelines" />
//                                         <p>
//                                             Manage Minings
//                                             <i className=" fas fa-angle-left right" />
//                                         </p>
//                                     </a>
//                                     <ul className="nav nav-treeview" style={{ display: 'none' }}>
//                                         <li className="nav-item super-admin" hidden>
//                                             <a href="/admin/mining-plans" className="nav-link">
//                                                 <i className="nav-icon fab" />
//                                                 <p>
//                                                     Plans
//                                                 </p>
//                                             </a>
//                                         </li>
//                                         <li className="nav-item">
//                                             <a href="/admin/all-minings" className="nav-link">
//                                                 <i className="nav-icon fab" />
//                                                 <p>
//                                                     All Minings
//                                                 </p>
//                                             </a>
//                                         </li>
//                                     </ul>
//                                 </li> */}
//                 <li className="nav-item">
//                   <a href="/investments" className="nav-link">
//                     <i className="nav-icon fas fa-hand-holding-usd" />
//                     <p>Manage Investments</p>
//                   </a>
//                 </li>

//                 <li className="nav-item">
//                   <a href="https://privateemail.com/" className="nav-link">
//                     <i className="nav-icon fas fa-envelope" />
//                     <p>webmail</p>
//                   </a>
//                 </li>
//                 <li className="nav-item">
//                   <a href="/logout" className="nav-link">
//                     <i className="nav-icon fas fa-power-off" />
//                     <p>Logout</p>
//                   </a>
//                 </li>
//               </ul>
//             </nav>
//             {/* /.sidebar-menu */}
//           </div>
//           {/* /.sidebar */}
//         </aside>
//         {/* Content Wrapper. Contains page content */}
//         <div className="content-wrapper" style={{ minHeight: "777px" }}>
//           {/* Content Header (Page header) */}
//           <section className="content-header">
//             <div className="container-fluid">
//               <div className="row mb-2">
//                 <div className="col-sm-6">
//                   <h1>Manage Deposits</h1>
//                 </div>
//                 <div className="col-sm-6">
//                   <ol className="breadcrumb float-sm-right">
//                     <li className="breadcrumb-item">
//                       <a href="https://chainblockinvestment.com/admin">Home</a>
//                     </li>
//                     <li className="breadcrumb-item active">Manage Deposits</li>
//                   </ol>
//                 </div>
//               </div>
//             </div>
//             {/* /.container-fluid */}
//           </section>
//           {/* Main content */}
//           <section className="content">
//             <div className="row">
//               <div className="col-md-12">
//                 <div className="row">
//                   <div className="col-md-12">
//                     <div className="card">
//                       <div className="card-body p-0">
//                         <div className="table-responsive">
//                           <div
//                             id="deposit_table_wrapper"
//                             className="dataTables_wrapper dt-bootstrap4 no-footer"
//                           >
//                             <div className="row">
//                               <div className="col-sm-12 col-md-6" />
//                               <div className="col-sm-12 col-md-6">
//                                 <div
//                                   id="deposit_table_filter"
//                                   className="dataTables_filter"
//                                 >
//                                   <label>
//                                     Search:
//                                     <input
//                                       type="search"
//                                       className="form-control form-control-sm"
//                                       placeholder
//                                       aria-controls="deposit_table"
//                                     />
//                                   </label>
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="row">
//                               <div className="col-sm-12">
//                                 <table
//                                   className="table table-striped dataTable no-footer"
//                                   id="deposit_table"
//                                   data-page-length={20}
//                                   role="grid"
//                                   aria-describedby="deposit_table_info"
//                                 >
//                                   <thead>
//                                     <tr role="row">
//                                       <th
//                                         style={{ width: "1%" }}
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         #
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       ></th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Name
//                                       </th>
//                                       <th
//                                         width="10%"
//                                         className="text-right sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         email
//                                       </th>
//                                       <th
//                                         width="5%"
//                                         className="text-center sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Usd Equivalent
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Wallet Address
//                                       </th>
//                                       <th
//                                         width="5%"
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Hash Code
//                                       </th>
//                                       <th
//                                         className="sorting_disabled"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Created Date
//                                       </th>
//                                       <th
//                                         className="text-center sorting_disabled"
//                                         width="10%"
//                                         rowSpan={1}
//                                         colSpan={1}
//                                       >
//                                         Action
//                                       </th>
//                                     </tr>
//                                   </thead>
//                                   <tbody>
//                                     {adminusers &&
//                                       adminusers.map((info, i) => {
//                                         return (
//                                           <tr
//                                             role="row"
//                                             className="odd"
//                                             key={info.userid}
//                                           >
//                                             <td>{i}</td>
//                                             <td>
//                                               <img
//                                                 src="https://img.icons8.com/bubbles/1x/administrator-male.png"
//                                                 className="img - fluid img - circle elevation - 2 bg - light"
//                                                 width="30px"
//                                                 alt="User Avatar"
//                                               />
//                                             </td>
//                                             <td>{info.fullname}</td>
//                                             <td>{info.email}</td>
//                                             <td>{info.info.amt}</td>
//                                             <td>{info.info.coin}</td>
//                                             <td>{info.info.date}</td>
//                                             <td>{cleanDate(info.info.date)}</td>
//                                             {/* <td>
//                                                                             1990-06-11
//                                                                         </td> */}
//                                             <td className="text-center">
//                                               {/* <button className="btn btn-dark btn-sm" onclick="confirmDeposit(267)">
//                                                                                 <i className="fas fa-check">
//                                                                                 </i>
//                                                                             </button> */}
//                                               <button
//                                                 className="btn btn-dark btn-sm"
//                                                 onClick={() => {
//                                                   UpdateDeposit(
//                                                     info.info,
//                                                     info.userid,
//                                                     info,
//                                                     info.id,
//                                                     info.fullname
//                                                   );
//                                                 }}
//                                               >
//                                                 <i className="fas fa-check"></i>
//                                               </button>

//                                               <button
//                                                 className="btn btn-danger btn-sm"
//                                                 onClick={() => {
//                                                   deleteDeposit(info.id);
//                                                 }}
//                                               >
//                                                 <i className="fas fa-trash"></i>
//                                                 Delete
//                                               </button>
//                                             </td>
//                                             <td>
//                                               <a
//                                                 href={info.info.image}
//                                                 target="_blank"
//                                                 rel="noopener noreferrer"
//                                               >
//                                                 {" "}
//                                                 view proof
//                                               </a>
//                                             </td>
//                                           </tr>
//                                         );
//                                       })}
//                                   </tbody>
//                                 </table>
//                               </div>
//                               <button
//                                 className="btn btn-danger btn-sm"
//                                 onClick={getNextDocuments}
//                               >
//                                 {/* <i className="fas fa-trash"> */}
//                                 {/* </i> */}
//                                 Load more
//                               </button>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                       {/* /.card-body */}
//                     </div>
//                   </div>
//                 </div>
//                 {/* /.box */}
//               </div>
//             </div>
//           </section>
//           {/* /.content */}
//         </div>
//         {/* /.content-wrapper */}
//         <footer className="main-footer">
//           <div className="float-right d-none d-sm-block">
//             <b>Version</b> 3.0.4
//           </div>
//           <strong>
//             Copyright © 2022{" "}
//             <a href="https://chainblockinvestment.com">Investment Admin</a>.
//           </strong>{" "}
//           All rights reserved.
//         </footer>
//         <div id="sidebar-overlay" />
//       </div>
//       {/* ./wrapper */}
//       {/* jQuery */}
//       {/* Bootstrap 4 */}
//       {/* AdminLTE App */}
//       {/* Sweet Alert */}
//       {/* Datatable */}
//       {/* for ladda */}
//     </div>
//   );
// }

// export default Deposits;
